/**
 * Appends the raw destination as a single-encoded `redirect_url` param.
 */
export const withRedirectUrl = (base: string, redirectUrl: string) =>
  `${base}?redirect_url=${encodeURIComponent(redirectUrl)}`
